import { FontAwesome5 } from '@expo/vector-icons';
import { styled, css } from '@openeducation/oe-rn-themes';
import { rgba } from 'polished';
import React, { memo } from 'react';
import type { StyleProp, ViewProps, ViewStyle } from 'react-native';
import type { FontAwesome5IconProps } from 'react-native-vector-icons/FontAwesome5';

import { TestId } from '../../constants/test-id';

export type CircleIconProps = FontAwesome5IconProps & {
  iconSize?: number;
  backgroundColor?: string;
  borderColor?: string;
  style?: StyleProp<ViewStyle>;
} & Pick<ViewProps, 'pointerEvents'>;

export const DEFAULT_CIRCLE_ICON_SIZE = 80;

const CircleIconComponent = ({
  name,
  size = DEFAULT_CIRCLE_ICON_SIZE,
  iconSize,
  solid = false,
  borderColor,
  backgroundColor,
  color,
  style,
  pointerEvents,
}: CircleIconProps) => (
  <Circle
    size={size}
    backgroundColor={backgroundColor}
    borderColor={borderColor}
    style={style}
    testID={TestId.CIRCLE_ICON}
    pointerEvents={pointerEvents}
  >
    <StyledIcon
      name={name}
      size={iconSize || size / 2}
      solid={solid}
      color={color}
    />
  </Circle>
);

type CircleType = {
  size: number;
  backgroundColor?: string;
  borderColor?: string;
};

const Circle = styled.View<CircleType>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size / 2}px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ?? rgba(theme.color.primary, 0.15)};
  ${({ borderColor }) =>
    borderColor &&
    css`
      border: 1px solid ${borderColor};
    `}
`;

const StyledIcon = styled(FontAwesome5).attrs(({ theme, color }) => ({
  color: color ?? theme.color.primary,
}))``;

export const CircleIcon = memo(CircleIconComponent);
